import { styled } from "@mui/material";

const StepNumberCircleStyled = styled("div")(({ active, completed }) => {
  let backgroundColor;
  if (active) {
    backgroundColor = "#FFFFFF";
  } else if (completed) {
    backgroundColor = "#00BDFF";
  } else {
    backgroundColor = "#155A7966";
  }

  return {
    width: 24,
    height: 24,
    border: active ? "3px solid #00BDFF" : "none",
    borderRadius: "50%",
    backgroundColor,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: active || completed ? "#155A79" : "#FFFFFF66",
    fontSize: 12,
    fontWeight: "bold",
    marginRight: 8,
    flexShrink: 0
  };
});

const StepNumberCircle = ({ active, completed, children }) => (
  <StepNumberCircleStyled active={active} completed={completed}>
    {children}
  </StepNumberCircleStyled>
);

export default StepNumberCircle;